import {SyncEventType} from '../../enums/syncEventType';
import {RealtimeEvent} from './realtimeEvent';

export class EventIssuecardClosed implements RealtimeEvent {

  public readonly type = SyncEventType.ISSUECARD_CLOSED;
  public issueId: number;
  public avatar: string;

  constructor(issueId: number, avatar: string) {
    this.issueId = issueId;
    this.avatar = avatar;
  }

  getPayload(): object {
    return {
      'issueId': this.issueId,
      'avatar': this.avatar
    };
  }

  static fromPayload(payload: any): EventIssuecardClosed {
    return new EventIssuecardClosed(
      payload['issueId'],
      payload['avatar']
    );
  }

}

